export default [
    "tr",
    "en"
]